<template>
  <!-- header -->
  <div class="position-fixed top-0 start-50 translate-middle-x w-100 mw-640 z-5 pb-1 bg-white">
    <div v-if="!check_if_client()" class="h-header w-100 d-flex align-items-center ps-4 pe-3">
      <header class="flex-grow-1 fs-6 text-muted d-flex align-items-center">
        <b>會員資訊</b>
      </header>
    </div>
  </div>
  
  <!-- main -->
  <main class="d-flex flex-column w-100 flex-1"
  :class="{'hideTitle': check_if_client()}">

  <!-- 顯示LINE名稱 -->
  <div class="px-4 my-3 text-center">您好，<b>{{displayName}}</b>！</div>
  
  <!-- 訂閱狀態 -->
  <div class="list-group list-group-flush">

    <!-- 訂閱中或即將到期 -->
    <div v-if="isActive || isCanceled || isPending || isVIP" class="p-3"
      :class="getStatusClass()"
    >
      <div class="d-flex justify-content-between align-items-center fw-semibold px-3 pb-2 placeholder-glow">
        <div class="small me-auto">方案類別</div>
        <span v-if="isLoading" class="placeholder col-4"></span>
        <span v-else>
          {{ mySubscription(subscription['SubscriptionID']).text }}
        </span>
      </div>
      <div class="d-flex justify-content-between align-items-center fw-semibold px-3 pb-2 placeholder-glow">
        <div class="small me-auto">訂單使用額度</div>
        <span v-if="isLoading" class="placeholder fs-5 col-3"></span>
        <b v-else class="fs-5">{{orderQuota.total_orders}} / <small>無限制</small></b>
      </div>
      <div v-if="!isVIP"
        class="d-flex justify-content-between align-items-center px-3 pb-2 placeholder-glow"
      >
        <template v-if="isLoading">
          <div class="flex-fill"></div>
          <span class="small placeholder col-4"></span>
        </template>
        <template v-else>
          <div class="small ms-auto">
            <span v-if="isActive">下次扣款日 {{ subscription['EndDate'] }}</span>
            <span v-else>將於 {{ subscription['EndDate'] }} 到期後限制額度</span>
          </div>
        </template>
      </div>
      <div v-if="isActive || isPending" class="flex-column flexCenter mt-2">
        <!-- isActive自動續訂開啟時顯示取消訂閱按鈕 -->
        <button v-if="isActive" @click="openModal('confirm')"
          class="btn btn-outline-light rounded-pill px-4 mb-2 d-block mx-auto fs-5.5">
          <b>取消訂閱</b>
        </button>
        <!-- isPending自動續訂付款失敗 -->
        <template v-if="isPending">
          <router-link to="/plan?resubscribe=true" role="button"
            class="btn btn-primary text-white rounded-pill px-4 mb-2 d-block mx-auto fs-5.5">
            <b>重新訂閱</b>
          </router-link>
          <small class="d-block text-center text-danger">
            提醒您：自動扣款失敗，服務可用至 {{ subscription['EndDate'] }}。<br>
            請確認信用卡資訊或重新訂閱，避免服務中斷。<br>
            * 如未處理，將於到期翌日自動停止訂閱。
          </small>
        </template>
      </div>
    </div>

    <!-- 非訂閱或已過期 -->
    <div v-else class="p-3"
      :class="getQuotaClass()"
    >
      <div class="d-flex justify-content-between align-items-center fw-semibold px-3 pb-2 placeholder-glow">
        <div class="small me-auto">方案類別</div>
        <span v-if="isLoading" class="placeholder col-4"></span>
        <span v-else>基本型</span>
      </div>
      <div class="d-flex justify-content-between align-items-center fw-semibold px-3 pb-2 placeholder-glow">
        <div class="small me-auto">訂單使用額度</div>
        <span v-if="isLoading" class="placeholder fs-5 col-3"></span>
        <b v-else class="fs-5">{{orderQuota.total_orders}} / {{orderQuota.quota_limit}}</b>
      </div>
      <div v-if="!isLoading" class="flex-column flexCenter mt-2">
        <div class="text-center mb-2 small">
          <b v-if="orderQuota.usage_percentage >= 100">您的使用額度已達上限！</b>
          <b v-else-if="orderQuota.usage_percentage >= 80">您的使用額度已達 8成！</b>
        </div>
        <router-link to="/plan" role="button" class="btn btn-primary text-white rounded-pill px-4 mb-2 d-block mx-auto fs-5.5">
          <b v-if="isFreePlan">立即升級以體驗完整功能！</b>
          <b v-else-if="isExpired">重新訂閱以恢復完整功能！</b>
          <b v-else>立即升級以體驗完整功能！</b>
        </router-link>
        <!-- 訂閱當下付款失敗提示 -->
        <small v-if="isPaymentFailed" class="text-center d-block text-danger">
          付款失敗：您的付款未成功處理。<br>
          請點擊按鈕重新嘗試。
        </small>
      </div>
    </div>

  </div>



  <div class="list-group list-group-flush">

    <!-- 有訂閱歷史時顯示 -->
    <template v-if="hasSubscriptionHistory">
      <a role="button" class="list-group-item list-group-item-action py-0"
        @click="openModal('user')"
      >
        <div class="p-3 border-bottom pe-0 d-flex justify-content-between align-items-center">
          <div class="me-auto">發票登錄資訊</div>
          <svg class="opacity-75" width="20" height="20"><use xlink:href="#forward"/></svg>
        </div>
      </a>
      
      <a role="button" class="list-group-item list-group-item-action py-0"
        data-bs-toggle="collapse" data-bs-target="#ordersInfo" aria-expanded="false" aria-controls="ordersInfo"
        @click="toggleRotation($event)"
      >
        <div class="p-3 border-bottom pe-0 d-flex justify-content-between align-items-center">
          <div class="me-auto">交易記錄</div>
          <svg class="opacity-75 rotate-icon" width="20" height="20"><use xlink:href="#forward"/></svg>
        </div>
      </a>
      <!-- 交易記錄顯示 -->
      <div class="collapse" id="ordersInfo">
        <div class="px-3">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">日期</th>
                <th scope="col">內容</th>
                <th scope="col">狀態</th>
                <th scope="col">金額</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="order in orders" :key="order.TransactionID">
                <td>{{ formatDateTime(order.UpdatedAt) }}</td>
                <td>{{ order.Content }}</td>
                <td>
                  <span v-if="order.Status === 'Success'">交易成功</span>
                  <span v-if="order.Status === 'Failed'">交易失敗</span>
                  <span v-if="order.Status === 'Canceled'">交易取消</span>
                </td>
                <td>{{ '$'+order.Amount }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>

    <!-- 常見 Q&A -->
    <a role="button" class="list-group-item list-group-item-action py-0"
      data-bs-toggle="collapse" data-bs-target="#faqInfo" aria-expanded="false" aria-controls="faqInfo"
      @click="toggleRotation($event)"
    >
      <div class="p-3 border-bottom pe-0 d-flex justify-content-between align-items-center">
        <div class="me-auto">常見 Q&A</div>
        <svg class="opacity-75 rotate-icon" width="20" height="20"><use xlink:href="#forward"/></svg>
      </div>
    </a>
    <div class="collapse px-3" id="faqInfo">
      <div class="accordion accordion-flush" id="faqAccordion">
        <!-- Q1: 方案差異 -->
        <div class="accordion-item">
          <b class="accordion-header" id="headingOne">
            <button
              class="accordion-button fs-6 collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="false"
              aria-controls="collapseOne"
            >
              Q1：基本型與進階型有什麼差別？
            </button>
          </b>
          <div
            id="collapseOne"
            class="accordion-collapse collapse"
            aria-labelledby="headingOne"
            data-bs-parent="#faqAccordion"
          >
            <div class="accordion-body pt-0 small">
              <p>
                <strong>基本型（免費方案）</strong>：可新增至
                <strong>50 筆訂單</strong>，含基本功能。
              </p>
              <p class="mb-2"><strong>進階型（付費方案）</strong>：</p>
              <ul class="mb-3">
                <li>👉 無限訂單容量</li>
                <li>👉 每季 <strong>299 元</strong> 💰｜年繳 <strong>999 元</strong> 🎁</li>
              </ul>

              <p class="fw-semibold mb-2">🚀 付費用戶專屬功能預告：</p>
              <ul class="mb-3">
                <li>📒 自動記錄老顧客與團隊夥伴資料</li>
                <li>🛍️ 訂單紀錄與聯絡方式清晰分類</li>
                <li>👥 快速搜尋熟客或團隊聯絡人</li>
                <li>🔔 自動收款 / 下單提醒</li>
              </ul>

              <p class="mb-0">
                ✔ <strong>免費用戶：</strong> 安心無負擔<br />
                ✔ <strong>升級用戶：</strong> 功能更全面 🚀
              </p>
            </div>
          </div>
        </div>

        <!-- Q2: 支付方式 -->
        <div class="accordion-item">
          <b class="accordion-header" id="headingTwo">
            <button
              class="accordion-button fs-6 collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              Q2：可以用其他支付方式訂閱嗎？
            </button>
          </b>
          <div
            id="collapseTwo"
            class="accordion-collapse collapse"
            aria-labelledby="headingTwo"
            data-bs-parent="#faqAccordion"
          >
            <div class="accordion-body pt-0 small">
              目前僅支援 <strong>信用卡付款</strong>。
            </div>
          </div>
        </div>

        <!-- Q3: 升降級 -->
        <div class="accordion-item">
          <b class="accordion-header" id="headingThree">
            <button
              class="accordion-button fs-6 collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              Q3：已訂閱中，可以升級 / 降級方案嗎？
            </button>
          </b>
          <div
            id="collapseThree"
            class="accordion-collapse collapse"
            aria-labelledby="headingThree"
            data-bs-parent="#faqAccordion"
          >
            <div class="accordion-body pt-0 small">
              目前尚未開放訂閱中途調整。若需變更方案，請聯繫客服協助處理。
            </div>
          </div>
        </div>

        <!-- Q4: 停止訂閱 -->
        <div class="accordion-item">
          <b class="accordion-header" id="headingFour">
            <button
              class="accordion-button fs-6 collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              Q4：停止訂閱後，我的訂單會保留嗎？
            </button>
          </b>
          <div
            id="collapseFour"
            class="accordion-collapse collapse"
            aria-labelledby="headingFour"
            data-bs-parent="#faqAccordion"
          >
            <div class="accordion-body pt-0 small">
              <p>不會刪除。您的訂單資料會完整保留：</p>
              <p class="mb-0">
                ✔ 可繼續編輯 <strong>最新 50 筆訂單</strong><br />
                ✔ 超出 50 筆的資料仍可檢視與查詢（但無法編輯）
              </p>
            </div>
          </div>
        </div>
      </div>

      <p class="ms-4 small text-muted">
        如有其他疑問，歡迎隨時聯繫我們的客服團隊！
      </p>
    </div>

    <!-- 客服 -->
    <a role="button" class="list-group-item list-group-item-action py-0 mb-4"
      @click="openModal('support')"
    >
      <div class="p-3 border-bottom pe-0 d-flex justify-content-between align-items-center">
        <div class="me-auto">客服支援</div>
        <svg class="opacity-75" width="20" height="20"><use xlink:href="#forward"/></svg>
      </div>
    </a>

    </div>

    <!-- <div class="px-4 mt-3 d-flex justify-content-between align-items-center">
      <div class="small text-muted">發票資訊</div>
      <button :disabled="isLoading" @click="openModal('user')"
        class="btn btn-outline-primary rounded-pill py-1 px-3 lh-1 flexCenter">
        <small>編輯</small>
      </button>
    </div>
    <div class="list-group list-group-flush">
      <li class="list-group-item py-0">
        <div class="p-3 border-bottom d-flex justify-content-between align-items-center placeholder-glow">
          <div class="me-auto">姓名</div>
          <span v-if="isLoading" class="placeholder col-3 fs-5.5"></span>
          <span v-else class="fs-5.5">{{subscription['Name']}}</span>
        </div>
      </li>
      <li class="list-group-item py-0">
        <div class="p-3 border-bottom d-flex justify-content-between align-items-center placeholder-glow">
          <div class="me-auto">Email</div>
          <span v-if="isLoading" class="placeholder col-6 fs-5.5"></span>
          <span v-else class="fs-5.5">{{subscription['Email']}}</span>
        </div>
      </li>
      <li v-if="subscription['Carrier']" class="list-group-item py-0">
        <div class="p-3 border-bottom d-flex justify-content-between align-items-center">
          <div class="me-auto">手機條碼載具</div>
          <span class="fs-5.5">{{subscription['Carrier']}}</span>
        </div>
      </li>
      <li v-if="subscription['TaxId']" class="list-group-item py-0">
        <div class="p-3 border-bottom d-flex justify-content-between align-items-center">
          <div class="me-auto">統一編號</div>
          <span class="fs-5.5">{{subscription['TaxId']}}</span>
        </div>
      </li>
    </div> -->

    <!-- <div class="px-4 mt-3 d-flex justify-content-between align-items-center">
      <div class="small text-muted">訂閱狀態{{myStatus(subscription['Status']).text}}</div>
    </div> -->


  </main>

  <!-- modal -->
  <div class="modal fade" id="modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-fullscreen modal-dialog-scrollable my-0">
      <div class="modal-content border-0 rounded-0">
        <!-- header -->
        <div class="modal-header h-42 py-0 px-3 border-0"
          :class="{
            'justify-content-end': type === 'user' || type === 'support',
            'justify-content-start': type === 'unsub'
          }">
          <button :disabled="isLoading" class="btn border-0 p-0 lh-1 opacity-75" type="button" data-bs-dismiss="modal" aria-label="Close" @click="cancel">
            <svg width="28" height="28">
              <use v-if="type === 'unsub'" xlink:href="#back"/>
              <use v-if="type === 'user' || type === 'support'" xlink:href="#close-lg"/>
            </svg>
          </button>
          <h6 v-if="type === 'unsub'" class="modal-title text-muted ms-1">取消訂閱確認</h6>
        </div>
        <!-- edit user -->
        <div v-if="type === 'user'" class="modal-body py-0">
          <form class="px-2">
            <div class="form-floating mb-2" :class="{ 'invalid': submitted && !name }">
              <input v-model="name" type="text" class="form-control" id="userName" placeholder="姓名" required>
              <label for="userName">姓名 <b class="text-danger">*</b></label>
            </div>
            <div class="small text-end mb-2">
              <span class="text-danger" v-show="submitted && !name">這是必填欄位</span>
            </div>

            <div class="form-floating mb-2" :class="{ 'invalid': (submitted && !my_email) || (my_email && !isValidEmail) }">
              <input v-model="my_email"  type="email" class="form-control" id="userEmail" placeholder="Email" required>
              <label for="userEmail">Email <b class="text-danger">*</b></label>
            </div>
            <div class="small text-end mb-2">
              <span class="text-danger" v-show="submitted && !my_email">這是必填欄位<br></span>
              <span class="text-danger" v-show="my_email && !isValidEmail">請輸入正確的email格式<br></span>
              <span class="text-muted">請輸入可接收電子發票通知的Email</span>
            </div>

            <div class="form-floating mb-2" :class="{ 'invalid': this.carrier && !isValidCarrier }">
              <input v-model="carrier" type="text" class="form-control" id="userCarrier" placeholder="手機條碼載具">
              <label for="userCarrier">手機條碼載具</label>
            </div>
            <div class="small text-end mb-2" v-show="this.carrier && !isValidCarrier">
              <span class="text-danger">請輸入正確的格式</span>
            </div>

            <div class="form-floating mb-2" :class="{ 'invalid': this.tax_id && !isValidTaxId }">
              <input v-model="tax_id" type="text" inputmode="numeric" class="form-control" id="userTaxId" placeholder="統一編號">
              <label for="userTaxId">統一編號</label>
            </div>
            <div class="small text-end mb-2" v-show="this.tax_id && !isValidTaxId">
              <span class="text-danger">請輸入正確的格式</span>
            </div>
          </form>
        </div>
        <!-- unsubscribe -->
        <div v-if="type === 'unsub'" class="modal-body py-0">
          <div class="px-2 text-justify">
            <h6 class="my-3">親愛的 <span class="text-primary">{{subscription['Name']}}</span> 您好：</h6>
            <p>感謝您對小美祕書服務的支持。我們很抱歉得知您欲取消訂閱。</p>
            <p>您的訂閱將於 <b>{{ subscription['EndDate'] }}</b> 結束。在此之前，您仍然可以享受我們的服務。</p>
            <p>訂閱結束後，您的訂單資料會完整保留，您仍然能編輯最新的 50 筆訂單，超出額度的資料僅提供檢視和查詢。</p>
            <p>如果這是誤操作，或者您有其他疑問，請聯繫我們的客戶服務。我們將竭誠為您提供協助。</p>
            <div class="pb-3">
              <p>為不斷提升我們的服務，希望您能提供取消訂閱的原因，這將有助於我們更好地理解您的需求。</p>
              <h6>請選擇您取消訂閱的主要原因：</h6>
              <div class="form-floating mb-3">
                <select class="form-select" id="reason" aria-label="reason">
                  <option value="服務表現未達預期">服務表現未達預期</option>
                  <option value="訂閱費用對我來說過高">訂閱費用對我來說過高</option>
                  <option value="我不再需要這項服務">我不再需要這項服務</option>
                  <option value="常常遇到技術問題或服務不穩定">常常遇到技術問題或服務不穩定</option>
                  <option value="我發現了更好或更適合的替代品">我發現了更好或更適合的替代品</option>
                  <option value="我目前暫時不需要這項服務">我目前暫時不需要這項服務</option>
                </select>
              </div>
              <textarea ref="textarea" rows="2" id="suggest" class="form-control border rounded rounded-3 mb-3" placeholder="其他意見與建議..."></textarea>
              <!-- <div class="form-floating">
                <textarea class="form-control px-0" placeholder="其他意見與建議" id="suggest" style="height: 100px"></textarea>
                <label for="suggest" class="px-0">其他意見與建議</label>
              </div> -->
            </div>

<!--             <div class="form-check mb-2">
              <input v-model="delChecked" class="form-check-input" type="checkbox" value="" id="deleteAccount">
              <label class="form-check-label" for="deleteAccount">
                解除訂閱後一併刪除帳號資料
              </label>
            </div>
            <div v-if="isChecked" class="alert alert-warning small p-2" role="alert">
              *勾選此選項將永久刪除您的所有帳戶相關資料，包括歷史訂單、個人資料等。此為不可逆操作，請謹慎考慮。如果您擔心資料儲存或隱私，建議在執行此操作前先備份重要資訊。
            </div> -->
            
            <p class="my-4">謝謝您的理解和合作，我們將不斷努力改進，期待能再次為您服務。</p>
            <p>祝您一切順利！</p>
            <p class="text-end"><b>小美祕書開發團隊</b></p>
          </div>
        </div>

        <!-- 客服支援 -->
        <div v-if="type === 'support'" class="modal-body py-0">
          <div class="px-2 text-justify">
            <h6 class="my-3">親愛的 <span class="text-primary">{{displayName}}</span> 您好：</h6>
            <p>感謝您使用小美祕書服務！我們致力於提供最佳的使用體驗，若您在使用過程中遇到任何問題或有任何建議，請隨時與我們聯繫。</p>
            <p>請在下方描述您的問題或建議，我們的客服團隊將盡快與您聯繫並提供協助。</p>
            <textarea ref="textarea" rows="2" id="suggest" class="form-control border rounded rounded-3 mb-3" placeholder="問題與建議..."></textarea>
            <p class="my-4">謝謝您的支持與理解，我們期待能持續為您提供優質的服務。</p>
            <p>祝您一切順利！</p>
            <p class="text-end"><b>小美祕書開發團隊</b></p>
          </div>
        </div>

        <div class="modal-footer">
          <button v-if="type === 'user'" @click="update()" :disabled="isLoading" class="btn btn-primary text-white w-100 h-48">
            <b>更新</b>
          </button>
          <button v-if="type === 'unsub'" @click="cancelSubscription()" :disabled="isLoading" class="btn btn-primary text-white w-100 h-48">
            <b>取消訂閱</b>
          </button>
          <!-- 客服支援 -->
          <button v-if="type === 'support'" @click="submitSupportRequest()" :disabled="isLoading" class="btn btn-primary text-white w-100 h-48">
            <b>送出</b>
          </button>
        </div>
      </div>
    </div>
  </div>

  <ConfirmModal ref="confirmModalRef"
  :title="'確定要取消訂閱嗎？'"
  @confirm="openModal('unsub')"
  />

  <!-- unsubscribed -->
  <div class="modal fade" id="unsubbedModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="unsubbedModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-sm modal-dialog-centered mx-auto" role="document">
      <div class="modal-content border-0 shadow">

        <!-- finished trial -->
        <!-- <div class="modal-body p-4">
          <p class="text-center"><b>您的試用已結束</b></p>
          <p>
            謝謝您使用小美祕書！<br>
            邀請您進入付費訂閱，立即繼續享受完整功能。再次感謝您的選擇，期待未來持續為您提供更多優質服務！
          </p>
          <small class="text-muted">* 到期日後7天內未處理，將自動取消訂閱。</small>
        </div> -->

        <!-- Pending Renewal Retry -->
        <!-- <div class="modal-body p-4">
          <p class="text-center"><b>您的支付未成功</b></p>
          <p>
            很抱歉，您的訂閱支付未成功處理，請確認並更新您的信用卡資訊，以確保訂閱服務的繼續使用。
          </p>
          <small class="text-muted">* 到期日後7天內未處理，將自動取消訂閱。</small>
        </div> -->

        <!-- expired -->
        <!-- <div class="modal-body p-4">
          <p class="text-center"><b>您的訂閱已結束</b></p>
          <p>
            感謝您對小美祕書的支持！您的訂閱已結束，非常感激您的陪伴。<br>
            重新訂閱即可再次體驗小美的優質功能和服務，期待您的回歸！
          </p>
        </div> -->

        <!-- finished unsubscribe -->
        <div class="modal-body p-4">
          <p class="text-center"><b>取消訂閱完成</b></p>
          <span>感謝您使用小美祕書，我們對您的支持深深感激。<br>期待有機會再次為您服務。</span>
        </div>

        <div class="modal-footer flex-nowrap p-0">
          <button :disabled="isLoading" type="button" class="btn btn-lg btn-link fs-6 text-decoration-none col-6 py-3 m-0 rounded-0 w-100" data-bs-dismiss="modal">確認</button>
        </div>
      </div>
    </div>
  </div>

  </template>
  
  <script>
  // import { ref } from 'vue';
  // import _ from 'lodash';
  import { Modal } from 'bootstrap';
  import liff from '@line/liff';
  import ConfirmModal from '@/components/ConfirmModal.vue';
  import axios from 'axios';
  import dayjs from 'dayjs';
  import { SubscriptionStatus } from '@/utils/setup.js';
  import DiscordNotification from '@/utils/discordNotification';
  let api_url = process.env.VUE_APP_API_URL;

  const PLAN_T = {
    "1": { text: "基本型/季付 $0" },
    "2": { text: "基本型/年付 $0" },
    "3": { text: "進階型/季付 $299" },
    "4": { text: "進階型/年付 $999" },
    "999": { text: "測試方案/日付 $10" },
    "9999": { text: "VIP" }
  };

  const STATUS_T = {
    "Active": { class: "fs-6 text-primary", text: "訂閱中" }, // isActive
    "Canceled": { class: "fs-6 text-secondary", text: "已取消訂閱" }, // isActive
    "Expired": { class: "fs-6 text-danger", text: "已過期" },
    "Pending Renewal": { class: "fs-6 text-danger", text: "待續訂" },
    "Pending Activation": { class: "fs-6 text-warning", text: "待啟用" }, // 修正：有空格
    "Disabled": { class: "fs-6 text-danger", text: "已停用" }
  };

  export default {
    name: 'UserCom',
    props: {
      userId: {
        type: String,
        default: null
      },
      token: {
        type: String,
        default: null
      },
      hasSubscriptionHistory: {
        type: Boolean,
        default: false
      }
    },
    components: {
      ConfirmModal,
    },
    data() {
      return {
        modal: null,
        type: null,
        isLoading: false,
        subscription: {
          "UserSubscriptionID": "",
          "UserID": "",
          "SubscriptionID": "",
          "StartDate": "",
          "EndDate": "",
          "Status": "",
          "AutoRenew": null,
          "Name": "",
          "Email": "",
          "Carrier": null,
          "TaxId": null
        },
        subscriptionStatus: null, // 訂閱狀態（包含 main 和 sub）
        orders: [],
        orderQuota: { // 訂單配額資訊
          total_orders: 0,
          quota_limit: 50,
          usage_percentage: 0,
          quota_exceeded: false
        },
        submitted: false,
        delChecked: false,
        // 編輯表單變數
        name: '',
        my_email: '',
        carrier: '',
        tax_id: ''
      }
    },
    mounted() {
      this.get_user_subscription().then(() => {
        if (this.subscription && this.subscription['Status'] === SubscriptionStatus.ACTIVE) {
          // this.createAndShowModal('unsubbedModal');
        }
      });
    },
    computed: {
      displayName() {
        return (this.$store && this.$store.getters && this.$store.getters.name)  || '';
      },
      isValidEmail() {
        return this.my_email && this.my_email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);
      },
      isValidTaxId() {
        return this.tax_id && this.tax_id.match(/^[0-9]{8}$/);
      },
      isValidCarrier() {
        return this.carrier && this.carrier.match(/^\/[0-9a-zA-Z+-.]{7}$/);
      },
      isChecked() {
        return !!this.delChecked;
      },
      isActive() { // 已啓用且自動續訂開啟（使用 API 實時狀態）
        return this.subscriptionStatus && 
               this.subscriptionStatus.main === 'Active' && 
               this.subscriptionStatus.sub === 'NORMAL';
      },
      isCanceled() { // 已取消訂閱但仍在有效期內（使用 API 實時狀態）
        return this.subscriptionStatus && 
               this.subscriptionStatus.main === 'Active' && 
               this.subscriptionStatus.sub === 'CANCEL';
      },
      isExpired() { // 已過期（使用 API 返回的實時狀態）
        return this.subscriptionStatus && this.subscriptionStatus.main === 'Expired';
      },
      isPending() { // 待續訂（使用 API 實時狀態）
        return this.subscriptionStatus && 
               this.subscriptionStatus.main === 'Pending Renewal';
      },
      isDisabled() { // 已停用（使用 API 實時狀態）
        return this.subscriptionStatus && this.subscriptionStatus.main === 'Disabled';
      },
      isPaymentFailed() { // 付款失敗
        return this.subscriptionStatus && 
               this.subscriptionStatus.main === 'Pending Activation' && 
               this.subscriptionStatus.sub === 'PAYMENT_FAILED';
      },
      isFreePlan() { // 未定閱狀態
        return !this.subscription || this.subscription['SubscriptionID'] === null;
      },
      isVIP() { // VIP 會員
        return this.subscription && this.subscription['SubscriptionID'] === '9999';
      }
    },
    methods: {
      check_if_client() {
        return liff.isInClient()
      },
      myStatus(status) {
          if (status === 'Active' && this.subscription && this.subscription.AutoRenew === false) {
            return { class: "fs-6 text-warning", text: "已取消自動續訂" };
          }
          return STATUS_T[status] || { class: "fs-6 text-danger", text: "未知狀態" };
      },
      mySubscription(plan) {
          return PLAN_T[plan] || { text: "未知方案" };
      },
      openModal(type) {
        this.type = type;
        if (type === 'confirm') {
          this.$refs.confirmModalRef.openModal();
        } 
        else if (type === 'unsubbed') {
          this.closeModal();
          this.createAndShowModal('unsubbedModal');
        } else {
          this.createAndShowModal('modal');
        }
      },
      createAndShowModal(id) {
        this.modal = new Modal(document.getElementById(id));
        this.modal.show();
      },
      closeModal() {
        this.modal.hide();
      },
      update() {
        this.submitted = true;
        if (!this.name || !this.my_email || !this.isValidEmail || (this.carrier && !this.isValidCarrier) || (this.tax_id && !this.isValidTaxId)) {
          return;
        } else {
          this.updateUserProfile();
        }
      },
      submitSupportRequest() {
        const suggestTextarea = document.getElementById('suggest');
        const supportMessage = suggestTextarea ? suggestTextarea.value : '';

        if (!supportMessage.trim()) {
          alert('請輸入您的問題或建議內容');
          return;
        }

        this.isLoading = true;

        // 發送 Discord 通知
        DiscordNotification.send({
          type: 'support',
          user: {
            user_id: this.userId,
              name: (this.subscription?.Name ? this.subscription.Name : '') +
                    (this.displayName ? ` (${this.displayName})` : '') || '未知',
            email: this.subscription?.Email || '未知'
          },
          message: supportMessage
        }).then(() => {
          this.isLoading = false;
          this.closeModal();
          this.$refs.textarea.value = '';
          alert('您的問題或建議已送出，我們將盡快與您聯繫。謝謝！');
        }).catch((error) => {
          console.error('Discord notification failed:', error);
          this.isLoading = false;
          alert('送出失敗，請稍後再試');
        });
      },
      // 更新使用者資料
      async updateUserProfile() {
        this.isLoading = true;
        
        try {
          const payload = {
            name: this.name,
            email: this.my_email,
            carrier: this.carrier || null,
            tax_id: this.tax_id || null
          };

          const response = await axios.put(`${api_url}/v1/users/${this.userId}/profile`, payload, {
            headers: {
              'Authorization': `Bearer ${this.token}`,
              "ngrok-skip-browser-warning": "69420"
            }
          });

          if (response.data.result === 'OK') {
            // 更新本地資料（確保 subscription 物件存在）
            if (this.subscription) {
              this.subscription.Name = this.name;
              this.subscription.Email = this.my_email;
              this.subscription.Carrier = this.carrier || null;
              this.subscription.TaxId = this.tax_id || null;
            }
            
            this.closeModal();
            alert('資料更新成功');
          } else {
            console.error('Update profile failed:', response.data);
            alert('更新失敗，請稍後再試');
          }

        } catch (error) {
          console.error('Error updating profile:', error);
          alert('更新失敗，請稍後再試');
        } finally {
          this.isLoading = false;
        }
      },
      // 取得使用者訂閱資料
      async get_user_subscription() {

        this.isLoading = true;
        
        try {

          let baseURL = `${api_url}/v1/users/${this.userId}/subscription`;

          const response = await axios.get(baseURL, {
            headers: {
              'Authorization': `Bearer ${this.token}`,
              "ngrok-skip-browser-warning": "69420"
            }
          });

          this.subscription = response.data['subscription'] || this.subscription;
          this.orders = response.data['orders'] || [];

          // 獲取訂閱狀態（包含 main 和 sub）
          try {
            const statusResponse = await axios.get(`${api_url}/v1/users/${this.userId}/subscription_status`, {
              headers: {
                'Authorization': `Bearer ${this.token}`,
                "ngrok-skip-browser-warning": "69420"
              }
            });
            this.subscriptionStatus = statusResponse.data;
          } catch (statusError) {
            console.error('Error fetching subscription status:', statusError);
          }

          // 獲取訂單配額
          try {
            const quotaResponse = await axios.get(`${api_url}/v1/users/${this.userId}/order_quota`, {
              headers: {
                'Authorization': `Bearer ${this.token}`,
                "ngrok-skip-browser-warning": "69420"
              }
            });
            this.orderQuota = quotaResponse.data;
          } catch (quotaError) {
            console.error('Error fetching order quota:', quotaError);
          }

          // 初始化編輯表單變數（只有在有訂閱記錄時才初始化）
          if (this.subscription && this.subscription.Name !== undefined) {
            this.name = this.subscription.Name || '';
            this.my_email = this.subscription.Email || '';
            this.carrier = this.subscription.Carrier || '';
            this.tax_id = this.subscription.TaxId || '';
          }

          this.isLoading = false;

        } catch (error) {
          console.error('Error sending GET request:', error);
          this.isLoading = false;
          return false;
        }
      },
      formatDateTime(dateTimeStr) {
        return dayjs(dateTimeStr).format('YYYY-MM-DD HH:mm:ss');
      },
      
      // 取消訂閱
      async cancelSubscription() {
        this.isLoading = true;
        
        try {
          // 獲取用戶填寫的取消原因和建議
          const reasonSelect = document.getElementById('reason');
          const suggestTextarea = document.getElementById('suggest');
          const cancelReason = reasonSelect ? reasonSelect.value : '未選擇';
          const cancelSuggestion = suggestTextarea ? suggestTextarea.value : '';
          
          const response = await axios.post(`${api_url}/v1/users/${this.userId}/cancel_subscription`, {}, {
            headers: {
              'Authorization': `Bearer ${this.token}`,
              "ngrok-skip-browser-warning": "69420"
            }
          });

          if (response.data.result === 'OK') {
            // 發送 Discord 通知
            try {
              await DiscordNotification.send({
                type: 'unsubscribe',
                user: {
                  user_id: this.userId,
                  name: this.subscription?.Name || '未知',
                  email: this.subscription?.Email || '未知'
                },
                subscription: {
                  plan: this.mySubscription(this.subscription?.SubscriptionID).text || '未知方案',
                  end_date: this.subscription?.EndDate || '未知'
                },
                feedback: {
                  reason: cancelReason,
                  suggestion: cancelSuggestion,
                  delete_account: this.delChecked
                }
              });
            } catch (discordError) {
              console.error('Discord notification failed:', discordError);
              // 即使 Discord 通知失敗也不影響取消訂閱流程
            }
            
            // 重新獲取訂閱資料以更新畫面
            await this.get_user_subscription();
            
            // 顯示取消成功modal
            this.closeModal();
            this.$refs.textarea.value = '';
            this.openModal('unsubbed');
          } else {
            console.error('Cancel subscription failed:', response.data);
            alert('取消訂閱失敗，請稍後再試');
          }

        } catch (error) {
          console.error('Error cancelling subscription:', error);
          alert('取消訂閱失敗，請稍後再試');
        } finally {
          this.isLoading = false;
        }
      },
      
      toggleRotation(event) { // 旋轉icon
        const icon = event.currentTarget.querySelector('.rotate-icon');
        icon.classList.toggle('rotated');
      },
      // 取得額度顯示的CSS class
      getQuotaClass() {
        if (this.orderQuota.usage_percentage >= 100) {
          return 'bg-danger-subtle text-danger';
        } else if (this.orderQuota.usage_percentage >= 80) {
          return 'bg-warning-mix-white-50 warning-mix-black-40';
        } else {
          return 'bg-dark-mix-white-90 text-muted';
        }
      },
      // 取得狀態顯示的CSS class
      getStatusClass() {
        if (this.isActive || this.isVIP) {
          return 'bg-primary text-white';
        } else if (this.isCanceled) {
          return 'bg-primary-subtle primary-mix-black-10';
        } else if (this.isPending) {
          return 'bg-warning-mix-white-50 warning-mix-black-40';
        } else {
          return 'bg-dark-mix-white-90 text-muted';
        }
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>

  $spacer: 0.875rem;
  $headerHeight: calc($spacer * 3);
  $primary: #00a8ca;

  .h-header {
    height: $headerHeight;
  }
  main {
    margin: $headerHeight 0 69.5px;
    &.hideTitle {margin: 0 0 69.5px;}
  }
  .list-group-item {
    border: 0;
    &:last-child > * {
      border-bottom: none!important;
    }
  }

  .modal-dialog-scrollable {
    height: 100%;
    @media (min-width: 576px) {
      max-width:640px;
      margin: auto;
    }
  }

  .text-justify {
    text-align: justify!important;
  }

  .form-floating > .form-select {
    height: 3rem!important;
    min-height: 3rem!important;
    padding-top: 6px !important;
    padding-bottom: 6px !important;
  }
  textarea.border {
    border: 1px solid #ced4da!important;
    &:hover {
      border-color: #00a8ca!important;
    }
  }

  .placeholder-glow > .placeholder {
    margin-top: 4px;
    margin-bottom: 4px;
    &.fs-5\.5 {
      margin-top: 4.5px;
      margin-bottom: 4.5px;
    }
    &.small {
      margin-top: 3.5px;
      margin-bottom: 3.5px;
    }
  }

  // 旋轉icon
  .rotate-icon {
    transition: transform 0.3s ease;
    transform: rotate(0deg);
    
    &.rotated {
      transform: rotate(90deg);
    }
  }
  </style>
  
  